function rfetch() {
    if (!window._restoredFetch) {
        const iframe = document.createElement('iframe');

        iframe.style.display = 'none';
        document.body.appendChild(iframe); // add element

        window._restoredFetch = iframe.contentWindow.fetch;
        window._restoredFetch = window.fetch;
    }

    return window._restoredFetch.apply(null, arguments);
}


function parseCartMarkup(text) {
    const html = document.createElement('div');
    html.innerHTML = text;

    return {
        items: html.querySelector('.cart__items'),
        content: html
        /*discounts: html.querySelector('.cart__discounts'),
        offers: html.querySelector('.cart__promo-gwp'),
        data: html.querySelector('[data-gift-product-data]')*/
    }
}

function updateCartMetrics(totalPrice, itemCount) {
    document.querySelector("[data-header-cart-count]")?.setAttribute("data-header-cart-count", itemCount);

    // TODO REPLACE JQUERY
    window.jQuery(document.querySelector("[data-site-header] [data-site-header-main]")).trigger('cartcount:update', {
        item_count: itemCount
    });

    const cartTotalValueListener = (_ref) => {
        let {
            price
        } = _ref;
        // TODO may need to update cart drawer total price here...
    };

    this.cartTotalValue = window.api.theme.useValue({
        name: 'cart:total',
        handler: cartTotalValueListener,
        initialValue: {
            price: totalPrice,
            compare_at_price: totalPrice
        }
    });
}

window.getCartProductMarkup = async function () {
    let url = ''.concat('/cart', '?t=').concat(Date.now());

    url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');

    return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
    })
        .then(response => response.text())
        .then(parseCartMarkup)
        .catch(e => console.error(e));
}

window.startCartLoading = function () {
    const cartDrawer = document.getElementById('cart-drawer');
    cartDrawer.classList.add("loading");
}

window.openCartDrawer = async function () {
    startCartLoading();
    const cartDrawer = document.getElementById('cart-drawer');

    const cartContents = await getCartProductMarkup();

    cartDrawer.querySelector(".cart-full").innerHTML = cartContents.content.innerHTML;

    const totalPrice = cartContents.items.dataset.cartSubtotal;
    const itemCount = cartContents.items.dataset.count;
    updateCartMetrics(totalPrice, itemCount);

    const cart_content = cartDrawer.querySelector(".cart-drawer__content");
    if (itemCount > 0) {
        cart_content.classList.add("cart-has-items");
        hydrateCartDrawer();
    }
    else {
        cart_content.classList.remove("cart-has-items");
    }

    document.querySelector("#cart-drawer").classList.remove("loading");
    window.buildProductAddons("cart");

    if (!cartDrawer.classList.contains('cart-page')) {
        cartDrawer.classList.add('is-active');
        document.querySelector("body").classList.add("cart-drawer-open");
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const cartDrawer = document.getElementById('cart-drawer');
    const cartToggle = document.querySelector('.site-header-button.site-header-cart-button');
    const cartClose = document.querySelector('.cart-drawer__close');
    const cartWrapper = document.querySelector('.cart-drawer-wrapper');

    //fixOldSafariCartFlow();



    hydrateCartDrawer();

    cartToggle.addEventListener('click', function (e) {
        e.preventDefault();
        cartDrawer.classList.add('is-active');
    });

    cartClose.addEventListener('click', function () {
        cartDrawer.classList.remove('is-active');
        document.querySelector("body").classList.remove("cart-drawer-open");
    });

    cartWrapper.addEventListener('click', function (ev) {
        if (ev.target != cartWrapper) return;
        cartDrawer.classList.remove('is-active');
        document.querySelector("body").classList.remove("cart-drawer-open");
    });
});

function fixOldSafariCartFlow() {
    /**
     * 44px is the height of the Safari overflow bar
     */
    const SAFARI_MOBILE_BOTTOM_MENU_HEIGHT = 65;

    function throttle(func, delay) {
        let lastCall = 0;

        return function (...args) {
            const now = Date.now();
            if (now - lastCall >= delay) {
                lastCall = now;
                return func.apply(this, args);
            }
        };
    };

    /**
     * When bottom > window.innerHeight, we know for a fact that `element` is
     * outside the window bounds. Normally, `position: fixed` keeps the element
     * inside the window bounds.
     *
     * @param {Element} element
     * @param {Number} offsetBottom - in pixels
     */
    const reactToSafariOverflowBar = (element, offsetBottom) => {
        const { bottom } = element.getBoundingClientRect();
        if (Math.floor(bottom) > window.innerHeight) {
            element.style.paddingBottom = "80px";
        } else {
            element.style.paddingBottom = "20px";
        }
    };

    const offsetBottom = 0;
    const stuckToBottom = document.getElementById('cart-drawer').querySelector('.cart-drawer__footer');

    /**
     * Handle scroll events. This listener should be removed if the component
     * is removed, but this serves its demo purposes.
     */
    window.addEventListener('scroll', throttle(() => reactToSafariOverflowBar(stuckToBottom, offsetBottom), 200));
    window.addEventListener('resize', throttle(() => reactToSafariOverflowBar(stuckToBottom, offsetBottom), 200));
}

function hydrateCartDrawer() {
    // TODO better error handling...
    try {
        hydrateRecomendations();
    } catch { };
    try {
        hydrateQuantities();
    } catch { };
    try {
        hydrateDiscounts();
    } catch { };
}

function hydrateDiscounts() {
    const form = document.querySelector(".coupon-entry");
    const couponInput = form.querySelector(".coupon-entry input");
    const couponApply = form.querySelector(".coupon-entry button");
    const error = form.querySelector(".coupon-entry .error");

    form.addEventListener("submit", async (ev) => {
        ev.preventDefault();

        const code = couponInput.value;

        startCartLoading();
        const discountResponse = await rfetch('/discount/' + code, {
            method: 'GET',
            redirect: 'error',
            headers: {
            }
        }).then(openCartDrawer).catch(e => {
            openCartDrawer();
            //error.innerText = "Could Not Apply Coupon";
            //document.querySelector("#cart-drawer").classList.remove("loading");
        });
    });

}

function hydrateRecomendations() {
    var swiper = new Swiper(".cart-drawer__upsell-items", {
        slidesPerView: 1.2,
        // TODO figure out number of slides at each BP
        breakpoints: {
            // when window width is >= 320px
            400: {
                slidesPerView: 1.5,
            },
            600: {
                slidesPerView: 2.5,
            },
        }
        /*navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
        }*/
    });

    const buyButtons = document.querySelectorAll(".cart-drawer__upsell-items .productitem--action-trigger.productitem--action-atc");
    buyButtons.forEach(el => {
        const variant_id = el.dataset.variantId;
        el.addEventListener("click", () => {
            startCartLoading();
            rfetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: [{
                        id: variant_id,
                        quantity: 1
                        // properties: {} // Optional: add custom line item properties
                    }]
                })
            }).finally(() => {
                openCartDrawer();
            })
        });
    });

}

function hydrateQuantities() {
    const quantitySelectors = document.querySelectorAll('.quantity-selector:not(.hydrated)');

    quantitySelectors.forEach(selector => {
        selector.classList.add("hydrated");
        const removeBtn = selector.querySelector('.remove-button');
        const addWishlistButton = selector.querySelector('.move-to-wishlist-button');
        const minusBtn = selector.querySelector('.minus');
        const plusBtn = selector.querySelector('.plus');
        const input = selector.querySelector('.quantity-input');
        const errorDiv = selector.querySelector('.quantity-error');
        const lineItemKey = selector.dataset.lineItemKey;

        function updateCart(newQuantity) {
            // TODO ALSO REMOVE ADDONS
            errorDiv.style.display = 'none';
            startCartLoading();

            return rfetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: lineItemKey,
                    quantity: newQuantity
                })
            })
                .then(response => response.json())
                .then(cart => {
                    openCartDrawer();
                })
                .catch(error => {
                    errorDiv.style.display = 'block';
                    input.value = input.dataset.currentQty;
                });
        }

        minusBtn.addEventListener('click', () => {
            const newQty = parseInt(input.value) - 1;
            if (newQty >= 0) {
                input.value = newQty;
                updateCart(newQty);
            }
        });

        plusBtn.addEventListener('click', () => {
            const newQty = parseInt(input.value) + 1;
            input.value = newQty;
            updateCart(newQty);
        });

        input.addEventListener('change', () => {
            let newQty = parseInt(input.value);

            if (isNaN(newQty) || newQty < 1) {
                newQty = 1;
            }

            input.value = newQty;
            updateCart(newQty);
        });

        removeBtn.addEventListener('click', () => {
            updateCart(0);
        });

        addWishlistButton.addEventListener('click', () => {
            SwymPageData = {
                epi: parseInt(selector.dataset.variantId), // Unique variant ID of the product
                empi: parseInt(selector.dataset.productId), // Master Product Id of the product
            };
            SwymPageData.et = 4;  // et 4 stands for wishlist event type  
            _swat.addToWishList(SwymPageData, function (e) { addWishlistButton.innerHTML = "Saved"; updateCart(0); });
        });
    });
}